export { rotate, dash, SVG, Circle, PageLoader } from "./CircleSpinner";
